<div class="logo-main-container">
  <img class="link-style-img" src="assets/logos/POLARIN_logo.png" alt="Polarin" />
</div>
